import { TradeOrderListPanel, type TradeOrderData } from "../TradeOrderComponentPrimitives";

export interface DeliveryPayHistoryProps {
    items?: TradeOrderData[];
    onPreview?: (payment: TradeOrderData) => void;
}

/** 单次提货收款记录，保留线下付款凭证查看回调。 */
export default function PayHistory({ items = [], onPreview }: DeliveryPayHistoryProps) {
    return (
        <TradeOrderListPanel
            title="提货收款记录"
            items={items}
            onAction={onPreview}
            columns={[
                { label: "收款编号", key: "id" },
                { label: "支付金额(元)", key: "amount" },
                { label: "支付时间", key: "payTime" },
                { label: "付款说明", key: "paymentInstruction" },
                { label: "支付状态", key: "state" }
            ]}
        />
    );
}
